import {Component} from "react";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import {Col, ControlLabel, FormControl, Grid, Row} from "react-bootstrap";
import ReactNotify from "react-notify";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import React from "react";
import EplatnosciTable from "./components/EplatnosciTable";
import EplatnosciService from "./EplatnosciService";
import {TopAlertInformacja} from "../../../../componentsTopsa/alerty/TopAlerts";
import BiletyService from "../biletyApi/BiletyService";
import TopIf from "../../../../componentsTopsa/if/TopIf";

export default class EplatnosciContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eplatnosci: [],
            czyMoznaWyczyscicSzukanie: false,
            strona: 1,
            ilosc: 15,
            pageable: {
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
            szukanyCiag: '',
            trwaSzukanie: false,
        };
        this.onChangeSzukajPlatnosc=this.onChangeSzukajPlatnosc.bind(this)
        this.onClickWyczysc=this.onClickWyczysc.bind(this)
        this.onSizePerPageList=this.onSizePerPageList.bind(this)
        this.onPageChange=this.onPageChange.bind(this)
    }

    componentDidMount(){
        this.pobierzPlatnosci(1,15)
    }

    pobierzPlatnosci(strona=this.state.strona, ilosc=this.state.ilosc){
        this.setState({trwaSzukanie: true, szukanyCiag: ''})
        EplatnosciService.getEPlatnosciPageable(strona-1,ilosc).then(function (response) {
            this.setState({
                eplatnosci:response.data.content,
                pageable: {
                    first: response.data.first,
                    last: response.data.last,
                    page: response.data.number,
                    size: response.data.size,
                    totalElements: response.data.totalElements,
                    totalPages: response.data.totalPages,
                },
                trwaSzukanie: false
            })
        }.bind(this)).catch(function (err) {
            this.setState({trwaSzukanie: false})
        }.bind(this))
    }

    onChangeSzukajPlatnosc(e){

        let szukanyCiag = e.target.value

        if(szukanyCiag.length>2){
            this.setState({trwaSzukanie: true})
            BiletyService.szukajPlatnosciTPAY(szukanyCiag).then(function (response) {
                this.setState({
                    eplatnosci:response.data.content,
                    czyMoznaWyczyscicSzukanie:true,
                    szukanyCiag: szukanyCiag,
                    strona: 1,
                    ilosc: 400,
                    trwaSzukanie: false,
                    pageable: {
                        totalElements: response.data.totalElements,
                    },
                })
            }.bind(this)).catch(function (err) {
                this.setState({trwaSzukanie: false})
            }.bind(this))
        }
        if(e.target.value.length === 0){
            this.setState({czyMoznaWyczyscicSzukanie:false})
            this.pobierzPlatnosci(1,15)
        }
    }

    onClickWyczysc(){
        this.setState({czyMoznaWyczyscicSzukanie:false,szukanyCiag:''})
        this.pobierzPlatnosci(1,15)
        document.getElementById('poleSzukaniaPlatnosci').value=''
    }

    onSizePerPageList(size) {
        this.setState({ilosc: size})
    }

    onPageChange(page, sizePerPage) {
        this.setState({strona: page})
        this.pobierzPlatnosci(page, sizePerPage)
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-biletami',
                                    text: 'Zarządzanie biletami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-biletami/eplatnosci', text: 'e-płatności'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <Row>
                                <Col xs={4}>
                                    <ControlLabel>Wyszukaj płatność po emailu, kodzie TPAY bądź kodzie EBUS</ControlLabel>
                                    <FormControl type={'text'} onChange={this.onChangeSzukajPlatnosc} id={'poleSzukaniaPlatnosci'}/>
                                    {
                                        Boolean(this.state.czyMoznaWyczyscicSzukanie)?
                                            <span
                                                style={{color:'firebrick', position:'absolute', right:'25px',
                                                    top:'32px', display:'inline-block', cursor:'pointer'}}
                                            onClick={this.onClickWyczysc}
                                            >
                                                <i className={'fa fa-times'}></i> wyczyść</span>
                                            :
                                            ''
                                    }
                                    <TopAlertInformacja text={'Minimum 3 znaki, automatyczne szukanie'}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.trwaSzukanie}>
                                <div id={'GenerowanieContainer'}>
                                    <h1>
                                        <i className={'fa fa-spinner fa-spin'}></i>
                                        <div>
                                            Trwa szukanie rekordów...
                                        </div>
                                        <h6>
                                            Proces ten może potrwać dłuższą chwilę
                                        </h6>
                                    </h1>
                                </div>
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <EplatnosciTable data={this.state.eplatnosci}
                                             pageable={this.state.pageable}
                                             ilosc={this.state.ilosc}
                                             strona={this.state.strona}
                                             onSizePerPageList={this.onSizePerPageList}
                                             onPageChange={this.onPageChange}
                                             czySzukanyCiag={this.state.szukanyCiag.length > 2}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/eplatnosci/EplatnosciContainer.js